import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as advance from "./style.module.scss";
import { AdvanceRocket } from "../../../../AdvanceRocket";
import { OurPartners } from "../../../../OurPartners";
export const Advance = () => {
  return (
    <>
      <AdvanceRocket bgColor={"#FAF6FF"}/>
      <OurPartners ttlClassName={`${main.mainTitle} ${advance.advance__title}`}/>
    </>
  );
};
